import InfoPurpleIcon from '@/shared/assets/info-purple.svg';

interface ForecastEmptyStateProps {
  title: string;
  description: string;
}

export const ForecastEmptyStateAlert = ({
  title,
  description,
}: ForecastEmptyStateProps) => (
  <div className="flex flex-col items-center justify-center gap-4 py-20">
    <div className="relative flex items-center justify-center">
      <div className="absolute size-14 rounded-full bg-custom-purple/50 blur-md" />
      <img src={InfoPurpleIcon} alt="" className="relative size-10" />
    </div>
    <div className="flex max-w-72 flex-col items-center gap-2 text-center">
      <p className="text-sm font-semibold text-white">{title}</p>
      <p className="text-xs text-white/80">{description}</p>
    </div>
  </div>
);
